import React from 'react';
import { hasPermissionForFuncInProject } from 'src/utils/controllerHasPermissionsAdapter';
import { ts } from 'src/utils/translate';
import { BTNS } from 'src/utils/constants';
import { Dropdown } from 'src/pages/OfferPage/DocuSectionButtons/Dropdown';
import { DropdownOptionButton } from 'src/pages/OfferPage/DocuSectionButtons/DropdownOptionButton';
import { SectionButton } from 'src/pages/OfferPage/DocuSectionButtons/SectionButton';
import {
  mapQuoteUserPropertiesToButtonDescriptors
} from 'src/pages/OfferPage/DocuSectionButtons/docuSectionButtonsUtils';
import { NormalOptionButton } from 'src/pages/OfferPage/DocuSectionButtons/NormalOptionButton';
import { ProjectQuoteUserProperties } from 'src/model/api/project.model';
import { ProjectQuoteFloorVisibility } from 'src/api/project-quote-ui-slice';
import { GetProjectTreeProjectChildNode } from 'src/model/api/get-project-tree-project-childnode.model';
import { SECTION_BUTTON_FLOOR_PREFIX } from 'src/pages/OfferPage/DocuSectionButtons/docuSectionButtonDefs';
import { GetQuoteResponse } from 'src/model/api/quote/get-quote-response.model';
import { PinoutData } from 'src/pages/OfferPage/pinouts/PinoutConverter';
import { NHCPinoutDevices } from 'src/model/api/nhc-pinout-devices';
import { FeatureFlagResponse } from 'src/model/api/feature-flag.model';
import { GetFloorRoomsDevice } from 'src/model/api/v2/data-contracts';

export const DocuSectionButtons = (
    {
      tableData,
      svgData,
      projectId,
      quoteUserProperties,
      floorVisibilities,
      projectTreeNodes,
      isPro,
      isBelgianUser,
      quote,
      devices,
      pinoutData,
      nhcPinoutData,
      cableListData,
      groupedDevicesData,
      featureFlag,
      lightingCalcs,
    }: {
      tableData: any[],
      svgData: any,
      lightingCalcs: any,
      projectId: number,
      quoteUserProperties: ProjectQuoteUserProperties,
      floorVisibilities: ProjectQuoteFloorVisibility[],
      projectTreeNodes: GetProjectTreeProjectChildNode[],
      isPro: boolean,
      isBelgianUser: boolean,
      quote: GetQuoteResponse,
      devices: GetFloorRoomsDevice[],
      pinoutData: boolean | undefined | PinoutData,
      nhcPinoutData: NHCPinoutDevices,
      cableListData: any,
      groupedDevicesData: any,
      featureFlag: FeatureFlagResponse
    }) => {

  const [highlightedBtn, setHighlightedBtn] = React.useState<any>(null);
  const [floorVisible, setFloorVisible] = React.useState({} as any);
  const [leftSideVisibility, setLeftSideVisibility] = React.useState({
    customization: true,
    sections: true,
  });

  let buttonDescs = mapQuoteUserPropertiesToButtonDescriptors(
      projectTreeNodes, quoteUserProperties, floorVisibilities, tableData, isPro, isBelgianUser, quote, devices,
      pinoutData, nhcPinoutData, cableListData, groupedDevicesData, featureFlag, svgData, lightingCalcs);

  return (
      <>
        {hasPermissionForFuncInProject("docu_sect.customize_docu", projectId) ? (
            <>
              <div
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    marginTop: 21,
                  }}
              >
                {ts('client_type', 'Client type')}:
                <div
                    style={{
                      fontWeight: 400,
                      marginTop: 19,
                      display: "flex",
                      alignItems: "center",
                      flex: 1,
                    }}
                >
                  <DropdownOptionButton
                      buttonDesc={buttonDescs.find((btn: any) => btn.buttonId === BTNS.CLIENT_TYPE)!!}/>
                </div>
              </div>
              <div
                  style={{
                    fontSize: 24,
                    fontWeight: 600,
                    marginTop: 31,
                    marginBottom: 30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flex: 1,
                  }}
              >
                {ts("customization", "Customization")}
                <Dropdown
                    dropdownActive={leftSideVisibility.customization}
                    onDropdownClick={(newState: any) => {
                      leftSideVisibility.customization = newState;
                      setLeftSideVisibility(Object.assign({}, leftSideVisibility));
                    }}
                />
              </div>
              {leftSideVisibility.customization ? (
                  <>
                    {buttonDescs
                    .filter((btn) => btn.section === 'customizations' && btn.customizable === true)
                    .map((btn) => {
                      if (btn && "values" in btn) {
                        return <DropdownOptionButton key={btn.buttonId} buttonDesc={btn}/>;
                      } else if (btn) {
                        return <NormalOptionButton key={btn.buttonId} buttonDesc={btn}/>;
                      }
                    })}
                  </>
              ) : null}
            </>
        ) : null}
        <div
            style={{
              fontSize: 24,
              fontWeight: 600,
              marginTop: 26,
              marginBottom: 22,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flex: 1,
            }}
        >
          {ts("q_sec_ttl", "Sections")}
          <Dropdown
              dropdownActive={leftSideVisibility.sections}
              onDropdownClick={(newState: any) => {
                leftSideVisibility.sections = newState;
                setLeftSideVisibility(Object.assign({}, leftSideVisibility));
              }}
          />
        </div>
        {leftSideVisibility.sections ? (
            <>
              {
                buttonDescs
                .filter((desc) => desc.section === 'sections' && desc.customizable)
                .map((btn, index) =>
                    <SectionButton
                        key={btn.buttonId}
                        hasDropdown={btn.buttonId.startsWith(SECTION_BUTTON_FLOOR_PREFIX)}
                        isHighlighted={highlightedBtn && highlightedBtn.buttonId == btn.buttonId}
                        buttonDesc={btn}
                        floorVisibilities={floorVisibilities}
                        setHighlightedBtn={setHighlightedBtn}
                    />
                )
              }
            </>
        ) : null}
      </>
  );
};
